import { z } from 'zod'
import { furnitureItemDtoSchema } from './furniture-item.dto.js'

/**
 * One line of a venue's furniture inventory: how much of a catalog item the
 * venue owns, and where it's available. `venueSpaceId` null = available to any
 * space in the venue; set = restricted to that one space.
 */
export const venueInventoryEntryDtoSchema = z.object({
  furnitureItemId: z.string().uuid(),
  item: furnitureItemDtoSchema,
  quantity: z.number().int().nonnegative(),
  venueSpaceId: z.string().uuid().nullable(),
})

export type VenueInventoryEntryDto = z.infer<typeof venueInventoryEntryDtoSchema>

/** A venue's full base inventory (the stock it owns, before per-event allocation). */
export const venueInventoryDtoSchema = z.object({
  venueId: z.string().uuid(),
  entries: z.array(venueInventoryEntryDtoSchema),
})

export type VenueInventoryDto = z.infer<typeof venueInventoryDtoSchema>
